$(document).ready(function () {
    if(document.getElementById("selected_value")) {
        var selectedAmount = document.getElementById("selected_value");
        var element = $('#selected-value-link');
        var _href = element.attr("href");

        function clearLink() {
            $('#selected-value-link').attr("href", _href.replace(/selected_value%3D\d{0,6}/, "selected_value%3D"));
        }

        function updateLink() {
            $('#selected-value-link').attr("href", _href.replace("selected_value%3D", "selected_value%3D".concat(selectedAmount.value)));
        }

        $(".select-amount").on('click', function () {
            var valueClicked = this.value;
            selectedAmount.value = valueClicked;
            clearLink();
            updateLink();
        });

        if(selectedAmount.value === "500") {
            document.getElementById("amount_500").click();
        } else if (selectedAmount.value === "1000") {
            document.getElementById("amount_1000").click();
        } else if (selectedAmount.value === "2000") {
            document.getElementById("amount_2000").click();
        } else if (selectedAmount.value === "4000") {
            document.getElementById("amount_4000").click();
        }
    }
});
